// @flow

import React from 'react';
import { createGlobalStyle } from 'styled-components';
import Header from '@icis/shared-header';
import Authenticate from './components/Authenticate';
import { loadAnalytics, trackPageView, trackAction } from './modules/Analytics';
import { Modal } from '@icis/ui-kit-pilet-lib';

loadAnalytics();

const GlobalStyle = createGlobalStyle`
  .request-tool--modal-modal-content {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0;
    }
  }
  #icis-app-root {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 100;
    height: 56px;
    width: 100vw;
  }
`;

const ModalComp = (props) => <Modal params={props} />;

const App = () => (
  <Authenticate>
    {({ authReady, auth, authFail, authRetry }) => (
      <>
        <GlobalStyle />
        <Header
          authFailed={authFail}
          authRetry={authRetry}
          authReady={authReady}
          onPageChange={window.headerConfig?.onPageChange}
          onAuthIssue={() => auth.silentLogin()}
          onLogout={() => auth.logout()}
          trackPageView={trackPageView}
          trackAction={trackAction}
          ModalComp={ModalComp}
        />
      </>
    )}
  </Authenticate>
);

export default App;
